module.exports = __webpack_public_path__ + "static/media/alien.104ac586.svg";